import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: 'ent.offerdetails.paymentplans.Installment Schedule Title',
        defaultMessage: 'Proposed Payment Schedule',
    },
    selectedPlan: {
        id: 'ent.offerdetails.paymentplans.Installment Schedule Plan Name',
        defaultMessage: 'Payment Plan: {planName}',
    },
    ok: {
        id: 'ent.offerdetails.paymentplans.Ok',
        defaultMessage: 'OK',
    },
});
